module.exports = "/lucky-balls/video/intro_en.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/video/intro_en.mp4
// module id = 883
// module chunks = 0